import { useSession } from "next-auth/react";
import { debateAlarmSubmit, useDebateAlarmOnoff } from "utils/clientAPIs/debate";
import { useRouter } from "next/router";
import { useState } from "react";
import { useReportAlarm } from "lib/analytics/react/hooks";

const useDiscussAlarm = () => {
    const { data: session }: any = useSession();
    const [alarmRegisterToast, setAlarmRegisterToast] = useState(false);

    const reportAlarm = useReportAlarm();
    const [DebateAlarmOnStatus, isValid, debateAlarmMutate] =
        useDebateAlarmOnoff();

    const router = useRouter();
    const debateAlarmRegister = async (
        optionalCheckState: boolean,
        alarmTrigger: "NEW" | "COMMENT",
        fromListId: string,
        reportId?: number,
    ) => {
        if (typeof window !== "undefined") {
            window.dataLayer.push({
                event: alarmTrigger === "NEW" ? "AlarmReport" : "report-comment-alarm-button",
            });
        }
        reportAlarm.start({
            report_id: reportId,
            from_list_id: fromListId,
        });
        if (!session) {
            router.push(`/login?from=${router.asPath}`);
            return;
        }
        await debateAlarmSubmit(
            session,
            {
                ...(alarmTrigger === "NEW" && {
                    isNewAgendaAlarmOn: true,
                    isPopularCommentAlarmOn: optionalCheckState,
                }),
                ...(alarmTrigger === "COMMENT" && {
                    isUserActionAlarmOn: true,
                }),
            },
            debateAlarmMutate,
            reportAlarm.success,
            reportAlarm.fail
        );
        setAlarmRegisterToast(true);
    };

    return {
        session,
        DebateAlarmOnStatus,
        isValid,
        debateAlarmRegister,
        alarmRegisterToast,
        setAlarmRegisterToast,
    };
}

export default useDiscussAlarm;
